module.exports = __webpack_public_path__ + "media/montering-2.dca415b7.mp4";